import { Helmet } from 'react-helmet-async';
import { LOGO_URL } from '../utils/seo';

const About = () => {
  return (
    <>
      <Helmet>
        <title>Over Timmers BV - Meer dan 25 jaar ervaring in Glas</title>
        <meta name="description" content="Leer meer over Timmers BV, uw partner in glasoplossingen. Met meer dan 25 jaar ervaring ontzorgen wij professionals in de glaswereld met een team van ruim 40 medewerkers." />
        <link rel="canonical" href="https://timmers-bv.nl/about" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Over Timmers BV - Meer dan 25 jaar ervaring in Glas" />
        <meta property="og:description" content="Met meer dan 25 jaar ervaring ontzorgen wij professionals in de glaswereld met een team van ruim 40 medewerkers." />
        <meta property="og:image" content={LOGO_URL} />
        <meta property="og:url" content="https://timmers-bv.nl/about" />
        <meta property="og:locale" content="nl_NL" />
      </Helmet>
      <main id="maincontent" className="page-main">
        <div className="page-title-wrapper">
          <h1 className="page-title">
            <span className="base">Timmers BV, al meer dan 25 jaar...</span>
          </h1>
        </div>

        <div className="columns">
          <div className="main">
            <div className="pagebuilder-column-group">
              <div className="pagebuilder-column-line">
                <div className="pagebuilder-column">
                  <div className="pagebuilder-banner-wrapper">
                    <div className="pagebuilder-overlay pagebuilder-poster-overlay">
                      <div className="pagebuilder-poster-content">
                        <div>
                          <h4 className="size-18">
                            <span style={{ color: '#222222' }}>
                              staan wij nog steeds achter onze missie; het ontzorgen&nbsp;
                            </span>
                            van professionals binnen glasverwerkende bedrijven. Met een sterk team van ruim
                            40 medewerkers hebben wij de sfeer en gemoedelijkheid van het familiebedrijf
                            nog altijd kunnen behouden, iets waar wij met z'n allen trots op zijn!
                          </h4>
                          <p>
                            Van directie tot binnendienst en van magazijn tot chauffeurs, service verlenen
                            en de klant centraal stellen staat in ons DNA. Met een ruime productkennis ligt
                            onze kracht in het ontzorgen en meedenken om de inkoop, uitvoering en rendement
                            van onze klanten te verbeteren.
                          </p>
                          <p>
                            Door kritisch te kijken naar een optimale samenstelling van het assortiment en
                            naar de juiste service-gerichtheid willen wij de samenwerking met onze klanten
                            en leveranciers graag versterken. Van kleine projecten tot grote renovatieprojecten,
                            Timmers biedt meer dan enkel glas. Heel handig is het dan om alle benodigde
                            artikelen voor een project op maat en in de juiste hoeveelheden door ons eigen
                            transport op locatie te laten leveren. Door het uitgebreide assortiment in glas,
                            glasartikelen en glasbeslag kunnen klanten bij ons terecht voor One Stop Shopping.
                          </p>
                          <p>
                            Dit resulteert in een optimale dienstverlening aan de medewerkers, een hogere
                            doorloopsnelheid van het project en een grotere tevredenheid van de eindklant.
                            Dit zorgt dan weer voor lagere totaalkosten en een verbetering van het rendement.
                          </p>
                          <p>
                            Trots zijn wij ook op onze nominatie voor de participatieprijs West-Brabant in 2018.
                            Als ambassadeur van Maatschappelijk Verantwoord Ondernemen in Oosterhout geloven wij
                            er in dat investeren in mensen de sleutel is tot een langdurige en stabiele werkrelatie.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Product Groups Section */}
            <div className="how-it-work">
              <div className="row-full-width-inner">
                <div className="title-block">
                  <h2 className="size-36" style={{ textAlign: 'center' }}>
                    Onze drie productgroepen
                  </h2>
                </div>
                <div className="pagebuilder-column-group">
                  <div className="pagebuilder-column-line" style={{ display: 'flex' }}>
                    <div className="pagebuilder-column col-content">
                      <div>
                        <p style={{ textAlign: 'center' }}>
                          <strong>Glas</strong><br />
                          Gehard glas - gelaagd glas - floatglas<br />
                          spiegels - beloopbaar glas - gelakt glas<br />
                          gehard/gelaagd glas - geemailleerd glas<br />
                          timeless glas - klep-, val- en draairamen<br />
                          steel look deuren - voorzetramen
                        </p>
                      </div>
                    </div>
                    <div className="pagebuilder-column col-content">
                      <div>
                        <p style={{ textAlign: 'center' }}>
                          <strong>Glasbeslag</strong><br />
                          Scharnieren - knoppen en grepen<br />
                          glasklemmen - schuifdeurbeslag<br />
                          beslag voor inloopdouches - sauna<br />
                          afdichtprofielen - montageprofielen
                        </p>
                      </div>
                    </div>
                    <div className="pagebuilder-column col-content">
                      <div>
                        <p style={{ textAlign: 'center' }}>
                          <strong>Glasartikelen</strong><br />
                          Glaslatten - glasprofielen - verstekstans<br />
                          kitten, lijmen en stopverf - glaslakken<br />
                          band en tape producten - ventilatie-<br />
                          roosters - gereedschappen
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Team Section */}
            <div className="meet-our">
              <div className="title-block">
                <h2 className="size-36" style={{ textAlign: 'center' }}>
                  Timmers verzorgt en ontzorgt
                </h2>
                <p style={{ textAlign: 'center' }}>
                  Onze slogan is al jaren "Timmers verzorgt en ontzorgt" en dat begint al bij het
                  eerste contact met ons offerte team of binnendienst medewerkers. Na het bestellen
                  zorgen onze magazijnmedewerkers ervoor dat alles zorgvuldig wordt gepickt en verpakt.
                  Vervolgens gaan onze eigen chauffeurs iedere dag op pad om uw bestelling veilig bij
                  u af te leveren.
                  <br /><br />
                  <strong>Iedere dag staan ruim 40 medewerkers met plezier voor u klaar!</strong>
                  <br />
                  Verzorgen en ontzorgen dat is wat wij doen. Dat is waar wij blij van worden, waar
                  wij goed in zijn en waardoor wij al meer dan 25 jaar als een betrokken en betrouwbare
                  partner zijn voor onze klanten.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default About;
